// These documentation titles have been moved clientside, as we discovered there were
// already 3 other files with the same hardcoded data. If adding a new title, please
// ensure that you update all 4 files (including this one).

// sync-start:documentation-programs 432898802 ./apps/khanacademy/src/scratchpad-documentation-package/pjs-documentation.tsx
// sync-start:documentation-programs 1474873288 ./apps/khanacademy/src/scratchpad-documentation-package/sql-documentation.tsx
// sync-start:documentation-programs 785018745 ./apps/khanacademy/src/scratchpad-documentation-package/webpage-documentation.tsx
export const documentationTitles: Array<string> = [
    "point(x, y) | ProcessingJS",
    "random(low, high) | ProcessingJS",
    "line(x1, y1, x2, y2) | ProcessingJS",
    "ellipse(x, y, w, h) | ProcessingJS",
    "rect(x, y, width, height, radius)",
    "stroke(r, g, b, a*) | ProcessingJS",
    "triangle(x1, y1, x2, y2, x3, y3) | ProcessingJS",
    "background(r, g, b, a*) | ProcessingJS",
    "fill(r, g, b, a*) | ProcessingJS",
    "noStroke() | ProcessingJS",
    "pow(num, exponent) | ProcessingJS",
    "strokeWeight(thickness) | ProcessingJS",
    "log(num) | ProcessingJS",
    "abs(num) | ProcessingJS",
    "noFill() | ProcessingJS",
    "for loops | JavaScript",
    "Defining your own functions | JavaScript",
    "text(message, x, y, width*, height*) | ProcessingJS",
    "image(image, x, y, width*, height*) | ProcessingJS",
    "textSize(size) | ProcessingJS",
    "debug(arg1, arg2, ...) | ProcessingJS",
    "keyIsPressed | ProcessingJS",
    "keyCode | ProcessingJS",
    "mouseIsPressed | ProcessingJS",
    "textFont(font, size*)    | ProcessingJS",
    "tan(deg) | ProcessingJS",
    "cos(deg) | ProcessingJS",
    "sin(deg) | ProcessingJS",
    "bezier(x1, y1, cx1, cy1, cx2, cy2, x2, y2) | ProcessingJS",
    "color(r, g, b, a*) | ProcessingJS",
    "if statements | JavaScript",
    "Arrays | JavaScript",
    "will it converge towards -1?",
    "mouseClicked() | ProcessingJS",
    "KeyCode Database",
    "arc(x, y, w, h, start, stop) | ProcessingJS",
    "quad(x1, y1, x2, y2, x3, y3, x4, y4) | ProcessingJS",
    "while (x < 250) { ... }",
    "mousePressed() | ProcessingJS",
    "mouseReleased() | ProcessingJS",
    "dist(x1, y1, x2, y2) | ProcessingJS",
    "angleMode | ProcessingJS",
    "textAlign(ALIGN, YALIGN) | ProcessingJS",
    "jQuery example: attr()",
    "day() | ProcessingJS",
    "blendColor(c1, c2, MODE) | ProcessingJS",
    "acos(val) | ProcessingJS",
    "height | ProcessingJS",
    "bezierPoint(a, b, c, d, t) | ProcessingJS",
    "rectMode(MODE) | ProcessingJS",
    "map(num, low1, high1, low2, high2) | ProcessingJS",
    "resetMatrix() | ProcessingJS",
    "CSS: The descendant selector",
    "PVector.add(vector) | ProcessingJS",
    "mouseOver() | ProcessingJS",
    "HTML: The h1 to h6 tags",
    "min(num1, num2) | ProcessingJS",
    "SQL: CREATE TABLE with foreign key reference",
    "PVector.heading2D()",
    "curveTangent(a, b, c, d, t) | ProcessingJS",
    "PVector.angleBetween(vector1, vector2) | ProcessingJS",
    "jQuery example: slideUp(), slideDown(), and slideToggle()",
    "bezierTangent(a, b, c, d, t) | ProcessingJS",
    "jQuery example: submit()",
    "max(num1, num2) | ProcessingJS",
    "jQuery Example: scroll()",
    "lerpColor(c1, c2, amount) | ProcessingJS",
    "curveTightness(tightness) | ProcessingJS",
    "SQL: SELECT with aggregate functions",
    "textWidth(str) | ProcessingJS",
    "HTML: The image tag",
    "jQuery example: html()",
    "atan(val) | ProcessingJS",
    "CSS: The element selector",
    "jQuery example: 'mousemove' event",
    "HTML: The a tag",
    "jQuery example: append()",
    "jQuery example: keyboard events",
    "PVector.array() | ProcessingJS",
    "asin(val) | ProcessingJS",
    "pmouseX / pmouseY | ProcessingJS",
    "bezierVertex(cx1, cy1, cx2, cy2, x, y) | ProcessingJS",
    "SQL: Transform SELECT results with CASE",
    "red(color) | ProcessingJS",
    "curve(x1, y1, x2, y2, x3, y3, x4, y4) | ProcessingJS",
    "print(data) | ProcessingJS",
    "PVector.mult(scalar) | ProcessingJS",
    "SQL: SELECTing rows",
    "blue(color) | ProcessingJS",
    "SQL: CREATE table with a primary key",
    "draw() | ProcessingJS",
    "CSS: The font-family property",
    "PVector(x, y) | ProcessingJS",
    "exp(num) | ProcessingJS",
    "PVector.limit(max) | ProcessingJS",
    "strokeCap(MODE) | ProcessingJS",
    "imageMode(MODE) | ProcessingJS",
    "jQuery example: fadeIn(), fadeOut(), and fadeToggle()",
    "HTML: The strong and em tags",
    "SQL: INSERTing values in tables",
    "month() | ProcessingJS",
    "HTML: The br tag",
    "SQL: JOIN on tables",
    "PVector.sub(x, y) | ProcessingJS",
    "beginShape()/endShape()",
    "ceil(num) | ProcessingJS",
    "pushMatrix()/popMatrix() | ProcessingJS",
    "loop() | ProcessingJS",
    "SQL: Grouping SELECT results with GROUP BY",
    "mouseX/mouseY | ProcessingJS",
    "PVector.rotate(deg) | ProcessingJS",
    "SQL: UPDATE and DELETE",
    "CSS: The id selector",
    "noise() | ProcessingJS",
    "textDescent() | ProcessingJS",
    "strokeJoin(MODE) | ProcessingJS",
    "jQuery example: 'mouseenter'/'mouseleave' events",
    "mouseMoved() | ProcessingJS",
    "Random(seed) | ProcessingJS",
    "PVector.div(scalar) | ProcessingJS",
    "floor(num) | ProcessingJS",
    "second() | ProcessingJS",
    "keyTyped() | ProcessingJS",
    "Program.restart() | ProcessingJS",
    "key | ProcessingJS",
    "jQuery example: show(), hide(), toggle()",
    "hour() | ProcessingJS",
    "jQuery example: text()",
    "colorMode(MODE) | ProcessingJS",
    "constrain(value, min, max) | ProcessingJS",
    "jQuery example: touch events",
    "green(color) | ProcessingJS",
    "PVector.cross(vector2) | ProcessingJS",
    "curvePoint(a, b, c, d, t) | ProcessingJS",
    "jQuery example: appendTo()",
    "brightness(color) | ProcessingJS",
    "frameCount | ProcessingJS",
    "round(num) | ProcessingJS",
    "SQL: Filtering with LIKE",
    "width | ProcessingJS",
    "printMatrix() | ProcessingJS",
    "SQL: CREATE table with multiple data types",
    "millis() | ProcessingJS",
    "textAscent() | ProcessingJS",
    "CSS: Pseudo-classes",
    "mag(x1, y1) | ProcessingJS",
    "SQL: Using SELECT with LIMIT",
    "PVector.normalize() | ProcessingJS",
    "jQuery example: prepend()",
    "CSS: The class selector",
    "HTML: The p tag",
    "println(data) | ProcessingJS",
    "SQL: ALTER TABLE",
    "jQuery example: animate()",
    "SQL: Specifying DEFAULT values in CREATE TABLE",
    "jQuery example: 'focus'/'blur' events",
    "PVector.mag() | ProcessingJS",
    "SQL: Using HAVING with GROUP BY",
    "SQL: ROUND and other core functions",
    "atan2(y, x) | ProcessingJS",
    "SQL: SELECTing with WHERE conditions",
    "year() | ProcessingJS",
    "SQL: SELECT with ORDER BY",
    "CSS: The font-size property",
    "jQuery example: draggable elements",
    "PVector.heading() | ProcessingJS",
    "keyPressed() | ProcessingJS",
    "mouseDragged() | ProcessingJS",
    "mouseButton | ProcessingJS",
    "CSS: The background-color property",
    "jQuery example: 'click' event",
    "PVector.get() | ProcessingJS",
    "HTML: The ul, ol, and li tags",
    "noLoop() | ProcessingJS",
    "keyReleased() | ProcessingJS",
    "PVector.set(x, y) | ProcessingJS",
    "saturation(color) | ProcessingJS",
    "jQuery example: drag and drop",
    "textLeading(dist) | ProcessingJS",
    "rotate(angle) | ProcessingJS",
    "frameRate(fps) | ProcessingJS",
    "jQuery example: each()",
    "jQuery example: change()",
    "lerp(num1, num2, amount) | ProcessingJS",
    "sqrt(num) | ProcessingJS",
    "curveVertex(x, y) | ProcessingJS",
    "translate(x, y) | ProcessingJS",
    "SQL: Filter with IN",
    "noiseDetail(octaves, falloff) | ProcessingJS",
    "jQuery example: 'mousedown'/'mouseup' events",
    "HTML: The table tags",
    "norm(num, low, high) | ProcessingJS",
    "sq(num) | ProcessingJS",
    "hue(color) | ProcessingJS",
    "CSS: The color property",
    "radians(angle) | ProcessingJS",
    "minute() | ProcessingJS",
    "mouseOut() | ProcessingJS",
    "playSound(sound) | ProcessingJS",
    "jQuery example: css()",
    "Google Web Fonts example",
    "degrees(angle) | ProcessingJS",
    "alpha(color) | ProcessingJS",
    "The % operator",
    "ellipseMode(MODE) | ProcessingJS",
    "PVector.dot(vector2) | ProcessingJS",
    "scale(amount) | ProcessingJS",
    "PVector.dist(vector2) | ProcessingJS",
    "Program.assertEqual() | ProcessingJS",
];
// sync-end:documentation-programs
